// src/components/DashboardLayout.js
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Sidebar from "../Layout/Sidebar";
import Topbar from "../Layout/Topbar";
import { encryptData } from "../Common/encryptionUtils";
import "./Premises.css";
import { ToastContainer, toast } from "react-toastify";
import { useToast } from "../../contexts/ToastContext";
import { apiRequest } from "../../services/api";
import Loader from "../Common/Loader";
import { Breadcrumb } from "react-bootstrap";
import { faL } from "@fortawesome/free-solid-svg-icons";
import { AccessLog } from "../../Utils/AccessLog";
import VerifyEmail from "../User/VerifyEmail";
import CryptoJS from "crypto-js";
const secretKey = "BusinessTimeWebKiosk";

const Premises = () => {
  const [loading, setLoading] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const navigate = useNavigate();
  const pageLoading = (data) => {
    setLoading(data);
  };
  const [customerAccountData, setCustomerAccountData] = useState("");

  const [activeMenu, setActiveMenu] = useState(null);
  const [showModal, setShowModal] = useState(false); // Track modal visibility
  const [premiseToDelete, setPremiseToDelete] = useState(null);

  const handleEditPremise = (premiseData) => {
    const stepOneData = {
      title: premiseData?.title,
      photo: "",
      name: premiseData?.name,
    };
    localStorage.setItem("stepOneData", JSON.stringify(stepOneData));
    const stepTwoData = {
      address1: premiseData?.address,
      address2: premiseData?.address2,
      phoneCode: premiseData?.country_code,
      country: premiseData?.country,
      state: premiseData?.state,
      city: premiseData?.city,
      timezone: premiseData?.time_zone,
      dateFormat: premiseData?.date_format,
    };
    localStorage.setItem("stepTwoData", JSON.stringify(stepTwoData));
    const stepThreeData = {
      openTime: premiseData?.open_time,
      closeTime: premiseData?.close_time,
    };

    localStorage.setItem("stepThreeData", JSON.stringify(stepThreeData));
    localStorage.setItem(
      "sensorDetails",
      JSON.stringify(premiseData?.emitterDetails)
    );
    localStorage.setItem("dateFormat", premiseData?.date_format);
    navigate("/premise/update", {
      state: { premise: premiseData }, // Passing premise data here
    });
    // Add your edit logic here
  };

  const handleUserListByPremise = (premiseData) => {
    const selectedPremiseData = {
      value: premiseData?.premise_id,
      label: `${premiseData?.name}, ${premiseData?.city}`,
      country_code: premiseData?.country_code,
      time_zone: premiseData?.time_zone,
      name: premiseData?.name,
      premise_id: premiseData?.premise_id,
      date_format: premiseData?.date_format,
      open_time: premiseData?.open_time,
      close_time: premiseData?.close_time,
      scheduler_feature: premiseData?.scheduler_feature,
    };

    console.log("selectedPremiseData--->", selectedPremiseData);

    localStorage.setItem(
      "selectedTopBarPremises",
      JSON.stringify(selectedPremiseData)
    );

    navigate("/users");
  };

  const handleRemovePremise = (premiseId) => {
    setPremiseToDelete(premiseId);
    setShowModal(true);
    // Add your remove logic here
  };

  const toggleMenu = (premiseId) => {
    setActiveMenu(activeMenu === premiseId ? null : premiseId);
  };

  // Confirm delete and call API
  const confirmDelete = () => {
    if (premiseToDelete) {
      handleRemovePremiseAPI(premiseToDelete);
      setShowModal(false);
      setPremiseToDelete(null);
    }
  };

  // Close modal
  const closeModal = () => {
    setShowModal(false);
    setPremiseToDelete(null);
  };

  const authToken = localStorage.getItem("authToken");

  const handleRemovePremiseAPI = async (premise_id) => {
    setLoading(true);
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const deletePremise = await apiRequest(
        `web_api/admin/deletePremise/${premise_id}`,
        "POST",
        null,
        headers
      );

      if (deletePremise?.data?.status === 200) {
        const policy_details = deletePremise.data;
        setLoading(false);
        fetchAllPremise();
        toast.success(policy_details.message, {
          position: "top-right",
          autoClose: 4000,
        });
      } else {
        // Handle API response with errors or non-200 status codes
        const errorMessage =
          deletePremise?.data?.message || "Something went wrong.";
        setLoading(false);
        toast.error(`${errorMessage}`, {
          position: "top-right",
          autoClose: 4000,
        });
      }
    } catch (error) {
      // Handle network or unexpected errors
      // console.error('Error while creating policy:', error);
      toast.error("Failed to delete premises. Please try again later.", {
        position: "top-right",
        autoClose: 4000,
      });
    }
  };

  const Title = "Premises";

  const { toastMessage, clearToast } = useToast();
  const [premiseList, setPremiseList] = useState([]);
  const [selectedPremise, setSelectedPremise] = useState(
    JSON.parse(localStorage.getItem("selectedTopBarPremises"))
  );
  const [searchTerm, setSearchTerm] = useState(""); // New state for search term

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value); // Update the search term as user types
  };

  const filteredPremises = premiseList.filter((premise) => {
    return (
      premise.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      premise.city.toLowerCase().includes(searchTerm.toLowerCase())
    );
  });

  useEffect(() => {
    if (toastMessage) {
      toast.success(toastMessage);
      clearToast(); // Clear the toast message after displaying it
    }
  }, [toastMessage, clearToast]);

  const customerDetails = JSON.parse(localStorage.getItem("customerDetails"));
  const fetchAllPremise = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${authToken}`,
      };
      const premiseResponse = await apiRequest(
        `web_api/admin/getPremisesByUserId?customer_account_id=${customerDetails?.customerAccountId}`,
        "GET",
        null,
        headers
      );

      if (
        premiseResponse?.data?.status_code === 200 &&
        premiseResponse?.data?.data?.premise_details
      ) {
        const premise_details = premiseResponse.data?.data?.premise_details;
        setPremiseList(premise_details);
        localStorage.setItem("PremisesList", JSON.stringify(premise_details));
        localStorage.removeItem("stepOneData");
        localStorage.removeItem("stepTwoData");
        localStorage.removeItem("stepThreeData");
        localStorage.removeItem("stepFourthData");
        localStorage.removeItem("sensorDetails");
        localStorage.removeItem("dateFormat");
        setTimeout(() => {
          pageLoading(false);
        }, 200);
      } else {
        localStorage.removeItem("stepOneData");
        localStorage.removeItem("stepTwoData");
        localStorage.removeItem("stepThreeData");
        localStorage.removeItem("stepFourthData");
        localStorage.removeItem("dateFormat");
        localStorage.removeItem("sensorDetails");
        setTimeout(() => {
          pageLoading(false);
        }, 200);
        console.error(
          "Error: Invalid status code",
          premiseResponse?.data?.status_code
        );
      }
    } catch (error) {
      console.error("Error fetching premises:", error);
      toast.error(`${error}`, {
        position: "top-right",
        autoClose: 4000,
      });
    }
  };

  useEffect(() => {
    pageLoading(true);
    fetchAllPremise();
  }, []);

  const handleAddPremise = () => {
    navigate("/premise/create");
  };

  const handlePremiseSelect = (selected) => {
    if (selected?.value) {
    }
  };

  const handleVerifyEmail = (premiseData) => {
    setPopupOpen(true);
    console.log("premiseselectedItem--->", premiseData);
    const selectedPremiseData = {
      value: premiseData?.premise_id,
      label: `${premiseData?.name}, ${premiseData?.city}`,
      country_code: premiseData?.country_code,
      time_zone: premiseData?.time_zone,
      name: premiseData?.name,
      premise_id: premiseData?.premise_id,
      date_format: premiseData?.date_format,
      open_time: premiseData?.open_time,
      close_time: premiseData?.close_time,
      scheduler_feature: premiseData?.scheduler_feature,
    };

    console.log("selectedPremiseData--->", selectedPremiseData);

    localStorage.setItem(
      "selectedTopBarPremises",
      JSON.stringify(selectedPremiseData)
    );

    // setSelectedPremise();
  };

  useEffect(() => {
    AccessLog("Premises");

    const stored = localStorage.getItem("verificationToken");
    console.log("stored--->", stored);
    if (stored) {
      const bytes = CryptoJS.AES.decrypt(stored, secretKey);
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);
      console.log("decrypted--->", decrypted);
      if (decrypted === "verified:true") {
        navigate("/users");
      } else {
        navigate("/premises");
      }
    } else {
      navigate("/premises");
    }
  }, []);

  const checkVerifedStatus = async () => {
    const encryptedCustomerId = encryptData(
      customerDetails.customerAccountId.toString()
    );
    const encryptedCustomerEmail = encryptData(
      customerDetails?.email?.toString()
    );
    const authToken = localStorage.getItem("authToken");
    const headers = {
      Authorization: `Bearer ${authToken}`,
    };
    const response = await apiRequest(
      `web_api/admin/getCustomerDataById?email=${encryptedCustomerEmail}`,
      "GET",
      null,
      headers
    );
    if (response?.data?.status_code == 200) {
      setCustomerAccountData(response.data?.data);
      // if (response.data?.data?.email_verified === 1) {
      //   setIsEmailVerified(true);
      //   setIsPhoneVerified(false);
      // } else {
      //   setIsEmailVerified(false);
      //   setIsPhoneVerified(true);
      // }
      // if (response.data?.data?.phone_number_verified === 1) {
      //   setIsPhoneVerified(true);
      // }
    } else {
    }
  };

  useEffect(() => {
    checkVerifedStatus();
  }, [loading]);

  return (
    <div className="dashboard-layout">
      <Sidebar selectedPremise={selectedPremise} />
      <div className="main-content dashboardMain">
        <Topbar onPremiseSelect={handlePremiseSelect} />
        <ToastContainer />
        {loading && <Loader />}
        <div className="content">
          <div className="contentHeader d-flex align-items-center justify-content-end pb-3">
            {/* Search bar on the same row */}
            <div className="search-bar">
              <input
                type="text"
                className="form-control"
                placeholder="Search..."
                value={searchTerm}
                onChange={handleSearchChange} // Handle input change
                autoComplete="off"
                name="search_query_premise"
              />
            </div>
          </div>
          {/* <div className="premiseDetails">
            <div className="row premisesListDiv">
              <div className="col-lg-12 policyAddRow PremiseCreateBtn">
                    <button className='btn policyAddBtn' onClick={()=>{handleAddPremise()}}> <i className="fa fa-plus" aria-hidden="true"></i> New Premises</button>
              </div>
              <div className="row mt-0 g-4">
                {filteredPremises.length > 0 ? (
                  filteredPremises.map((premiseData) => (
                    <div
                      className="col-12 col-sm-6 col-md-4 col-lg-3 d-flex justify-content-center"
                      key={premiseData.premise_id}
                    >
                      <div
                        className="card setting-card"
                        onClick={() => handleCardClick(premiseData)} // Handle card click
                        style={{ cursor: "pointer" }}
                      >
                        <div className="card-image-div">
                          <img
                            src={premiseData.photo}
                            className="card-img-top"
                            alt={premiseData.title}
                          />
                        </div>
                        <div className="card-body">
                          <h5 className="card-title">{premiseData.name}</h5>
                          <p className="card-text">
                            {premiseData.city} - {premiseData.state}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div
                    className="noPolicyDiv d-flex flex-column align-items-center justify-content-start vh-100 bg-custom"
                    style={{
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                      color: "#fff",
                      textAlign: "center",
                    }}
                  >
                    <h1 style={{ fontSize: "1.2rem", fontWeight: "bold", color: "#2d64bc" }}>
                      No Premises Found
                    </h1>
                    <p
                      style={{
                        fontSize: "0.9rem",
                        marginTop: "10px",
                        maxWidth: "600px",
                        color: "#6c6c6c",
                      }}
                    >
                      Currently, there are no premises available. Create a new premise to get started.
                    </p>
                    <button
                      className="btn policyAddBtn"
                      style={{ padding: "4px 10px", fontSize: "0.8rem" }}
                    >
                      <i className="fa fa-plus p-1" aria-hidden="true"></i>
                      Create Premises
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>   */}

          <div className="premiseDetails">
            <div className="row premisesListDiv">
              {/* <div className="col-lg-12 policyAddRow PremiseCreateBtn">
                <button className="btn policyAddBtn" onClick={handleAddPremise}>
                  <i className="fa fa-plus" aria-hidden="true"></i> New Premises
                </button>
              </div> */}
              <div className="row mt-0 g-4">
                {filteredPremises.length > 0 ? (
                  filteredPremises.map((premiseData) => (
                    <div
                      className="col-12 col-sm-6 col-md-4 col-lg-3 d-flex justify-content-center"
                      key={premiseData.premise_id}
                    >
                      <div className="card setting-card position-relative">
                        <div className="card-image-div">
                          <img
                            src={premiseData.photo}
                            className="card-img-top"
                            alt={premiseData.title}
                            style={{ cursor: "pointer" }}
                            onClick={() => handleVerifyEmail(premiseData)}
                          />
                        </div>
                        <div className="card-body">
                          <h5
                            className="card-title"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleVerifyEmail(premiseData)}
                          >
                            {premiseData.name}
                          </h5>
                          <p
                            className="card-text"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleVerifyEmail(premiseData)}
                          >
                            {premiseData.city} - {premiseData.state}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div
                    className="noPolicyDiv d-flex flex-column align-items-center justify-content-start vh-100 bg-custom"
                    style={{
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                      color: "#fff",
                      textAlign: "center",
                    }}
                  >
                    <h1
                      style={{
                        fontSize: "1.2rem",
                        fontWeight: "bold",
                        color: "#2d64bc",
                      }}
                    >
                      No Premises Found
                    </h1>
                    <p
                      style={{
                        fontSize: "0.9rem",
                        marginTop: "10px",
                        maxWidth: "600px",
                        color: "#6c6c6c",
                      }}
                    >
                      Currently, there are no premises available. Create a new
                      premise to get started.
                    </p>
                    {/* <button
                      className="btn policyAddBtn"
                      style={{ padding: "4px 10px", fontSize: "0.8rem" }}
                      onClick={handleAddPremise}
                    >
                      <i className="fa fa-plus p-1" aria-hidden="true"></i>
                      Create Premises
                    </button> */}
                  </div>
                )}
              </div>
            </div>
            {showModal && (
              <div
                className="modal show d-block"
                tabIndex="-1"
                role="dialog"
                style={{
                  backgroundColor: "rgba(0, 0, 0, 0.5)", // Dimmed background
                }}
              >
                <div className="modal-dialog">
                  <div className="modal-content rounded-3 shadow-lg">
                    <div className="modal-header bg-primary deleteMgeHeader text-white">
                      <h5 className="modal-title">
                        <i className="bi bi-exclamation-triangle-fill me-2"></i>
                        Confirm Delete
                      </h5>
                      <button
                        type="button"
                        className="btn-close btn-close-white"
                        onClick={closeModal}
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body text-center">
                      <p className="text-secondary modal-body-desc">
                        Are you sure you want to delete this premises? <br />
                        {/* <strong>This action cannot be undone.</strong> */}
                      </p>
                    </div>
                    <div className="modal-footer d-flex justify-content-center">
                      <button
                        type="button"
                        className="btn btn-secondary px-4 deleteNoBtn"
                        onClick={closeModal}
                        style={{ borderRadius: "8px" }}
                      >
                        No
                      </button>
                      <button
                        type="button"
                        className="btn btn-danger px-4 deleteYesBtn"
                        onClick={confirmDelete}
                        style={{ borderRadius: "8px" }}
                      >
                        Yes
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <VerifyEmail
              open={popupOpen}
              handlePopUpClose={() => setPopupOpen(false)}
              navigate={navigate}
              type={"CustomerAccountPhoneVerify"}
              customerAccountData={customerAccountData}
              setLoading={setLoading}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Premises;
